import "./App.css";
import Main from "./Component/Main";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ProductDetail from "./Component/ProductDetail";
import CartPage from "./Component/CartPage";
import CheckOut from "./Component/CheckOut";
import { CartProvider } from "./Component/CartContext";
import PaySuccess from "./Component/SuccessPay";
import Shop from "./Component/Shop";
import Contact from "./Component/Contact";
import About from "./Component/About";
import Header from "./Component/Header";
import Footer from "./Component/Footer";
import Faqs from "./Component/Faqs";
import PolicyPage from "./Component/PolicyPage";
import PolicyIndex from "./Component/PolicyIndex";
import { policyRoutes } from "./Datas/policyData";

function App() {
  return (
    <CartProvider>
      <Router>
        <Header />
        <Routes>
          <Route path="/about" element={<About />} />
          <Route path="/" element={<Main />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/policies" element={<PolicyIndex />} />
          {policyRoutes.map((policy) => (
            <Route
              key={policy.path}
              path={policy.path}
              element={<PolicyPage policyKey={policy.key} />}
            />
          ))}
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/shopDetails/:id" element={<ProductDetail />} />
          <Route path="/cartpage" element={<CartPage />} />
          <Route path="/checkout" element={<CheckOut />} />
          <Route path="/paysuccess" element={<PaySuccess />} />
          <Route path="/payment" element={<PaySuccess />} />
        </Routes>
        <Footer />
      </Router>
    </CartProvider>
  );
}

export default App;
